import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const STEPS = ["3", "2", "1", "KICK OFF"];

export default function KickoffOverlay({ onDone }) {
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (step >= STEPS.length) {
      const t = setTimeout(onDone, 550);
      return () => clearTimeout(t);
    }
    const t = setTimeout(() => setStep((s) => s + 1), step === 0 ? 750 : 680);
    return () => clearTimeout(t);
  }, [step, onDone]);

  const label = STEPS[Math.min(step, STEPS.length - 1)];

  return (
    <motion.div
      key="kickoff-overlay"
      data-testid="kickoff-overlay"
      className="fixed inset-0 z-[100] bg-[#0A0A0A] flex flex-col items-center justify-center overflow-hidden"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
    >
      {/* pitch stripes bleeding through the dark */}
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "repeating-linear-gradient(to right, #84E116 0, #84E116 140px, transparent 140px, transparent 280px)",
        }}
        aria-hidden="true"
      />
      <p className="font-broadcast text-[#84E116] text-[10px] sm:text-sm tracking-[0.45em] uppercase mb-6">
        Advaith vs Life · Match Day 01
      </p>
      <div className="relative h-[150px] sm:h-[230px] w-full flex items-center justify-center">
        <AnimatePresence mode="wait">
          <motion.span
            key={label}
            className={`font-display uppercase text-[#84E116] ${
              label === "KICK OFF"
                ? "text-5xl sm:text-7xl lg:text-8xl"
                : "text-[110px] sm:text-[180px]"
            }`}
            initial={{ opacity: 0, scale: 0.4, rotate: -6 }}
            animate={{ opacity: 1, scale: 1, rotate: 0 }}
            exit={{ opacity: 0, scale: 1.35 }}
            transition={{ duration: 0.32, ease: [0.22, 1.3, 0.36, 1] }}
          >
            {label}
          </motion.span>
        </AnimatePresence>
      </div>
      <div className="mt-8 flex items-center gap-3">
        <span className="w-2 h-2 bg-[#FF3B30] live-dot" />
        <span className="font-broadcast text-white/60 text-[10px] sm:text-[11px] tracking-[0.3em] uppercase">
          Pre-match sequence
        </span>
      </div>
    </motion.div>
  );
}
